import store from '@/store'
import Vue from 'vue'

export default class FetchWrapper {
  static async get (url: string) {
    const response = await fetch(url, {
      cache: 'no-cache',
      headers: { Authorization: `Bearer ${store.state.access_token}` }
    })
    if (response.status === 401) {
      Vue.prototype.$buefy.dialog.confirm({
        title: 'Session expired',
        message: 'Your session has expired. Please login again.',
        canCancel: false,
        onConfirm: () => {
          store.commit('loggedIn', false)
          store.commit('accessToken', null)
          window.location.href = '/home'
        }
      })
    }
    const contentLength = response.headers.get('content-length')

    if (contentLength === '0' || contentLength === null) {
      return null
    }
    const resp = await response.json()
    if (resp.error) {
      throw resp.error
    } else if (resp.statusCode) {
      return { error: `Server error. ${resp.statusCode}` }
    }
    return resp
  }

  static async getBlob (url: string) {
    const response = await fetch(url, {
      cache: 'no-cache',
      headers: { Authorization: `Bearer ${store.state.access_token}` }
    })
    if (response.status === 401) {
      Vue.prototype.$buefy.dialog.confirm({
        title: 'Session expired',
        message: 'Your session has expired. Please login again.',
        canCancel: false,
        onConfirm: () => {
          store.commit('loggedIn', false)
          store.commit('accessToken', null)
          window.location.href = '/home'
        }
      })
    }
    return await response.blob()
  }

  static async post (url: string, body: any) {
    const request = new Request(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${store.state.access_token}`
      }
    })
    const response = await fetch(request)
    if (response.status === 401) {
      Vue.prototype.$buefy.dialog.confirm({
        title: 'Session expired',
        message: 'Your session has expired. Please login again.',
        canCancel: false,
        onConfirm: () => {
          store.commit('loggedIn', false)
          store.commit('accessToken', null)
          window.location.href = '/home'
        }
      })
    }
    const resp = await response.json()

    if (resp.error) {
      throw resp.error
    } else if (resp.statusCode) {
      return { error: `Server error. ${resp.statusCode}` }
    }
    return resp
  }

  static async postForm (url: string, form: any) {
    const request = new Request(url, {
      method: 'POST',
      body: form,
      headers: {
        Authorization: `Bearer ${store.state.access_token}`
      }
    })
    const response = await fetch(request)
    if (response.status === 401) {
      Vue.prototype.$buefy.dialog.confirm({
        title: 'Session expired',
        message: 'Your session has expired. Please login again.',
        canCancel: false,
        onConfirm: () => {
          store.commit('loggedIn', false)
          store.commit('accessToken', null)
          window.location.href = '/home'
        }
      })
    }
    const resp = await response.json()
    if (resp.error) {
      throw resp.error
    } else if (resp.statusCode) {
      return { error: `Server error. ${resp.statusCode}` }
    }
    return resp
  }
}
